var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { EnvironmentService, handleResponseWithExplicitErrorMessage, HttpCacheType, HttpContentType, HttpHeaderType, HttpMethodType, TranslationService } from "../../common";
/**
 * Service for submitting estimator summary
 * @class IntelligentPhotoCaptureEstimatorSummarySubmitService
 */
export class IntelligentPhotoCaptureEstimatorSummarySubmitService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    /**
     * Submits estimator summary for the given context
     * @param companyCode - The company code
     * @param contextId - The context identifier
     * @returns Promise with the estimator summary submit response data
     */
    submitEstimatorSummary(companyCode, contextId) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${EnvironmentService.getEnvironment().apdApiGatewayRoot}photo-based-estimating-orch-api/v1/companies/${companyCode}/contexts/${contextId}/estimator-summary/submit`;
            const apiRequest = new Request(uri, {
                method: HttpMethodType.POST,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
                    [HttpHeaderType.ACCEPT_LANGUAGE]: TranslationService.getCurrentLanguage()
                })
            });
            return yield this.fetchWrapper(apiRequest).then(response => handleResponseWithExplicitErrorMessage(response)
                .then(resolvedResponse => {
                return Promise.resolve(resolvedResponse);
            })
                .catch(error => {
                return Promise.reject(JSON.parse(error));
            }));
        });
    }
}
//# sourceMappingURL=IntelligentPhotoCaptureEstimatorSummarySubmitService.js.map